import { render, staticRenderFns } from "./P5.vue?vue&type=template&id=abad5cfc&scoped=true"
import script from "./P5.vue?vue&type=script&lang=ts"
export * from "./P5.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abad5cfc",
  null
  
)

export default component.exports